import { Result } from "src/utils/Result"
import { deleteTrashedMail } from "src/aws/customAPI"
import { execApi } from "src/apis/execApi"
import { appInfo } from "src/constants/AppInfo"

type DeleteContactParams = {
  accessToken: string
  myMemberId: string
  contactId: string
}

type DeleteContactSuccess = unknown

type DeleteContactFailure = {
  message: string
}

export const deleteContactTrashbox = async (params: DeleteContactParams): Promise<Result<DeleteContactSuccess, DeleteContactFailure>> => {
  const {accessToken, myMemberId, contactId} = params

  return execApi(
    () => deleteTrashedMail(accessToken, {
      input: {
        memberId: myMemberId,
        mailId: contactId
      },
      appInfo
    }),
    _ => undefined,
    {
      identifiers: ["deleteContactTrashbox", "deleteTrashedMail"],
      defaultErrorMessage: "連絡の削除に失敗しました"
    }
  )
}
